<template>
  <div
    id="onCurStock"
    style="background-color: #fff;"
  >
    <p class="title">Currency Indices & Equity Indices</p>
    <!-- Revised on 2022-03-05 -->
    <el-row style="width: 100%;height: calc(100% - 53px)">
      <el-col
        :sm="12"
        :md="15"
        :xl="18" style="height: 100%"
      >
        <div id="onCurStockTop">
          <div style="width:100%;height:95%;padding:0 10px 0 10px;">
            <!-- Revised on 2022-03-05 -->
            <el-table
              ref="paritiesTable"
              @row-click="getChartData"
              :row-class-name="rowClassName"
              :cell-class-name="cellClassName"
              :data="forexData"
              border
              height="height: calc(100% - 53px);"
              v-loading="dataListLoading"
              style="width: 100%; height: 100%"
              class="el-le"
            >
              <!-- Revised on 2022-03-05 -->
              <el-table-column
                width="80"
                prop="LABEL"
                :show-overflow-tooltip="true"
                label='Symbol'
                align="center"
              >
              </el-table-column>
              <el-table-column
                width="80"
                :show-overflow-tooltip="true"
                prop="clsPrc"
                label='Last'
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="ntChg1"
                align="center" 
                label='Change'
              >
              </el-table-column>
              <el-table-column
                width="100"  
                align="center"              
                :show-overflow-tooltip="true"
                prop="ntChgp1"
                label='Change(%)'
              >
              </el-table-column>
              <el-table-column
                prop="openPrc"
                label='Open'
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="dHPrc"
                label='High'
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="dLPrc"
                label='Low'
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="lastCls"
                label='PreClose'
                align="center"
              >
              </el-table-column>
              
              <el-table-column
                prop="time1"
                label='Time'
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="date1"
                label='Date'
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
      <el-col
        :sm="12"
        :md="9"
        :xl="6"
        style="height: 100%;"
      >
        <div id="onCurStockBottom">
          <rate-chart v-if="isOk" :row="row"></rate-chart>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
/* eslint-disable no-unused-vars,keyword-spacing */

import stomp from 'stompjs'
import { CNF_SOCKET_SERVICE, CNF_SOCKET_USERNAME, CNF_SOCKET_PASSWORD, CNF_TICK_SERVICE } from 'common/js/http/v3Api.js'
import RateChart from './xhs/RateChart'
import ExchangeRateChart from './xhs/ExchangeRateChart'
import lclsBPRC from './xhs/lclsBPRC'
import { getAseanIndex } from "common/js/http/v3Api"
export default {
  props: {
    isOk: Boolean,
    countryId: String
  },
  data() {
    return {
      clientHeight: '',
      other: null,
      forexData: [],
      row: {},
      ws: null,
      client: null,
      CON: null,
      lastTime: {},
      dataListLoading: false,
      id: 'F03_01_01_T',
      pagesize: '',
      begindate: '',
      enddate: '',
      // 定时器
      timer: null,
    }
  },
  created() {
    this.timer = setInterval(() => {
      this.getAseanIndex()
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  components: {
    RateChart,
    ExchangeRateChart,
    lclsBPRC
  },
  mounted() {
    this.getAseanIndex()
  },
  methods: {
    async getAseanIndex() {
      const { data } = await getAseanIndex({
      }, { 'Content-Type': 'application/json;charset=utf8', 'API-TOKEN': '3E5BF2A64E87D6D8936E3ABFCFD86F2D' });
      let indexData = data.result.data.data
      let indexDataList = []
      this.forexData = [];
      if (indexData != null) {
        for (let item in indexData) {
          indexDataList.push({...indexData[item], id: item})
        }
      }
      if (indexDataList != null && indexDataList.length !== 0) {
        let labelObj = {
          "22": "IDX_ASEAN",
          "2040012000000001": "000300.CSI",
          "2040603000000001": "000001.SH",
          "2040604000000001": "399001.SZ",
          "2049995000000001": "SET.TH",
          "2049996000000001": "JKSE.ID",
          "2049997000000001": "STI.SG",
          "2049998000000001": "KLSE.MY"
        }
        indexDataList.map((item, index) => {
          item.LABEL = labelObj[item.id];
          item.time1 = this.timestampToTime(item.date1, 'time')
          item.date1 = this.timestampToTime(item.date1, 'date')
          item.ntChgp1 = item.ntChgp1.toString().match(/^\d+(?:\.\d{0,2})?/)
        })
        this.forexData = indexDataList
        this.row = indexDataList[0]
        // this.initTableData()
      }
      this.dataListLoading = false
    },
    initTableData() {
      var codeids = ''
      for (var i = 0; i < this.forexData.length; i++) {
        codeids += this.forexData[i].codeId
        if (i !== this.forexData.length - 1) {
          codeids += ','
        }
      }
      this.$axios.get((CNF_TICK_SERVICE + codeids), {
        headers: { 'content-type': 'application/x-www-form-urlencoded' }
      }).then(({ data }) => {
        try {
          for (var i in data) {
            for (var j = 0; j < this.forexData.length; j++) {
              if (i.toString() === this.forexData[j].CODE_ID.toString()) {
                var index = JSON.parse(data[i])
                this.forexData[j].bid1 = index.bid1
                this.forexData[j].ask1 = index.ask1
                this.forexData[j].ntChg1 = index.ntChg1
                this.forexData[j].openBPrc = index.openBPrc
                this.forexData[j].dHPrc = index.dHPrc
                this.forexData[j].dLPrc = index.dLPrc
                this.forexData[j].lclsBPRC = index.lclsBPrc
                this.forexData[j].time1 = this.timestampToTime(index.time1, 'time')
                this.forexData[j].date1 = this.timestampToTime(index.date1, 'date')
                break
              }
            }
          }
        } catch (e) {
        }
        // this.initSocket()
      })
    },
    initSocket() {
      this.ws = new WebSocket(CNF_SOCKET_SERVICE)
      this.client = stomp.over(this.ws)
      this.client.heartbeat.outgoing = 2000
      this.CON = this.client.connect(CNF_SOCKET_USERNAME, CNF_SOCKET_PASSWORD, this.connectCallback, this.errorCallback)
    },
    getChartData(row) {
      this.row = row
      sessionStorage.setItem('AseanIndexRow', JSON.stringify(this.row));//重点在这里
      this.isOk = true;
    },
    connectCallback() {
      for (var i = 0; i < this.forexData.length; i++) {
        this.client.subscribe('/index/' + this.forexData[i].XCODE.substring(2), this.onmessage)
      }
    },
    errorCallback() {
      if (this.ws.readyState === 3) {
        this.ws.close()
        this.ws = new WebSocket(CNF_SOCKET_SERVICE)
        this.client = stomp.over(this.ws)
        this.client.connect({
          'login': 'caohaiwang'
        }, this.connectCallback, this.errorCallback)
      }
    },
    onmessage(message) {
      var body = JSON.parse(message.body)
      // 更新数据
      for (var i = 0; i < this.forexData.length; i++) {
        if (this.forexData[i].CODE_ID.toString() === body.codeId.toString()) {
          var time = null
          var bid1 = this.$refs.paritiesTable.$el.getElementsByClassName('row' + body.codeId)[0].getElementsByClassName('colbid1')
          var ask1 = this.$refs.paritiesTable.$el.getElementsByClassName('row' + body.codeId)[0].getElementsByClassName('colask1')
          var ntChg1 = this.$refs.paritiesTable.$el.getElementsByClassName('row' + body.codeId)[0].getElementsByClassName('colntChg1')
          if (this.lastTime[body.xcode + '1'] !== null && this.lastTime[body.xcode + '1'] !== undefined) {
            clearTimeout(this.lastTime[body.xcode + '1'])
          }
          if (this.lastTime[body.xcode + '2'] !== null && this.lastTime[body.xcode + '2'] !== undefined) {
            clearTimeout(this.lastTime[body.xcode + '2'])
          }
          if (this.lastTime[body.xcode + '3'] !== null && this.lastTime[body.xcode + '3'] !== undefined) {
            clearTimeout(this.lastTime[body.xcode + '3'])
          }
          if (body.bid1 > this.forexData[i].bid1) {
            this.updateCss(bid1, 'up')
            time = setTimeout(() => { this.updateCss(bid1, 'normal') }, 3000)
          } else if (body.bid1 < this.forexData[i].bid1) {
            this.updateCss(bid1, 'down')
            time = setTimeout(() => { this.updateCss(bid1, 'normal') }, 3000)
          } else {
            this.updateCss(bid1, 'normal')
          }
          this.lastTime[body.xcode + '1'] = time
          if (body.ask1 > this.forexData[i].ask1) {
            this.updateCss(ask1, 'up')
            time = setTimeout(() => { this.updateCss(ask1, 'normal') }, 3000)
          } else if (body.ask1 < this.forexData[i].ask1) {
            this.updateCss(ask1, 'down')
            time = setTimeout(() => { this.updateCss(ask1, 'normal') }, 3000)
          } else {
            this.updateCss(ask1, 'normal')
          }
          this.lastTime[body.xcode + '2'] = time

          if (body.ntChg1 > this.forexData[i].ntChg1) {
            this.updateCss(ntChg1, 'up')
            time = setTimeout(() => { this.updateCss(ntChg1, 'normal') }, 3000)
          } else if (body.ntChg1 < this.forexData[i].ntChg1) {
            this.updateCss(ntChg1, 'down')
            time = setTimeout(() => { this.updateCss(ntChg1, 'normal') }, 3000)
          } else {
            this.updateCss(ntChg1, 'normal')
          }
          this.lastTime[body.xcode + '3'] = time
          this.forexData[i].clsPrc = body.clsPrc // last
          this.forexData[i].bid1 = body.bid1 // 买价
          this.forexData[i].ask1 = body.ask1 // 卖价
          this.forexData[i].ntChg1 = body.ntChg1// 涨跌
          this.forexData[i].ntChgp1 = body.ntChgp1          
          this.forexData[i].openPrc = body.openPrc// 开盘
          this.forexData[i].dHPrc = body.dHPrc// 日高
          this.forexData[i].dLPrc = body.dLPrc// 日低
          this.forexData[i].lastCls = body.lastCls// 上收盘
          this.forexData[i].time1 = this.timestampToTime(body.time1, 'time')
          this.forexData[i].date1 = this.timestampToTime(body.date1, 'date')
        }
      }
    },
    rowClassName(e) {
      return 'row' + e.row.CODE_ID
    },
    cellClassName(e) {
      return 'col' + e.column.property
    },
    addClass(kls, dom) {
      var klsReg = new RegExp(kls, 'ig')
      for (var i = 0; i < dom.length; i++) {
        var node = dom[i]
        var klses = node.className
        if (!klsReg.test(klses)) {
          node.className = klses + ' ' + kls
        }
      }
    },
    removeClass(kls, dom) {
      var klsReg = new RegExp(kls, 'ig')
      for (var i = 0; i < dom.length; i++) {
        var node = dom[i]
        var klses = node.className
        if (klsReg.test(klses)) {
          node.className = node.className.replace(kls, '')
        }
      }
    },
    updateCss(e, s) {
      if (s === 'up') {
        this.removeClass('up', e)
        this.removeClass('down', e)
        this.removeClass('normal', e)
        this.addClass('up', e)
      } else if (s === 'down') {
        this.removeClass('up', e)
        this.removeClass('down', e)
        this.removeClass('normal', e)
        this.addClass('down', e)
      } else {
        this.removeClass('up', e)
        this.removeClass('down', e)
        this.removeClass('normal', e)
        this.addClass('normal', e)
      }
    },
    timestampToTime(timestamp, format) {
      var date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = date.getDate() + ' '
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      if (format === 'date') {
        return Y + M + D // + h + m + s
      }
      if (format === 'time') {
        return h + m + s
      }
      return Y + M + D // + h + m + s
    }
  }
}
</script>

<style scoped lang="scss">
#onCurStock {
  width: 100%;
  height: 100%;
}
#onCurStock #onCurStockTop {
  width: 100%;
  height: 100%;
  position: relative;
}
#onCurStock #onCurStockBottom {
  width: 100%;
  height: 100%;
  //height: 310px;
  padding: 0 10px 0 10px;
}

#onCurStock .title {
  font-size: 16px;
  color: rgb(69, 155, 239);
  margin: 0 0 10px 10px;
  border-bottom: 1px solid #dedede;
  line-height: 2;
}

.up {
  background-color: #e9b9ba !important;
  color: #ff5e57 !important;
  .cell {
    background-color: #e9b9ba !important;
    color: #ff5e57 !important;
  }
}
.down {
  background-color: #c5dcb9 !important;
  color: #68a240 !important;
  .cell {
    background-color: #e9b9ba !important;
    color: #ff5e57 !important;
  }
}
.normal {
  background-color: transparent !important;
  color: #333 !important;
}

/deep/.el-table td,
/deep/.el-table th.is-leaf {
  border: none;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #cde5e3;
}
/deep/.el-table .cell {
  /* white-space:nowrap; */
  line-height: 16px !important;
}

/deep/ tr:nth-of-type(even) {
  background: rgb(249, 245, 252) !important;
}
/deep/.el-table th {
  background: rgb(238, 247, 255);
  color: rgb(69, 155, 239);
}
/deep/.el-table__row .cell {
  font-size: 13px;
  padding: 0;
  /*color:#636363;*/
}
.has-gutter .cell {
  font-size: 14px;
  color: #4b4b4b;
}
.el-loading-spinner .path {
  stroke: #fff0;
}
.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.66);
}
</style>
